import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";

export const RefreshButtonContainer = styled.div`
  ${({ theme }: NectarTheme) => css`
    font-size: ${theme.typography.text.sm};
    white-space: nowrap;

    & button {
      border: 1px solid ${theme.colors.gray300} !important;
      text-transform: none;
      display: flex;
      align-items: center;
      font-weight: ${theme.fontWeight.semiBold};
      gap: ${theme.spacings.xs};
      cursor: pointer;
    }
  `}
`;
